import { observable, action } from 'mobx';
import {WeaForm} from 'comsMobx';
import * as API from '../apis/rewardsrecord';
import * as Util from '../util/index';
import {WeaTableNew} from 'comsMobx'
const {TableStore} = WeaTableNew;
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

export class HrmRewardsRecord {
  title = () => getLabel('16065',"奖惩考核");
  tabDatas = () => [
    {title:getLabel('32740',"我的成绩"),key:"1"},
    {title:getLabel('15682',"奖惩情况"),key:"2"}
  ];

  @observable form = new WeaForm();
  @observable table = new TableStore();
  @observable tabkey = '1';
  @observable tableinfo = [];
  @observable isshowrecord = false;

  @action
  getData(params = {}) {
    this.getSearchList();
  }

  doSearch(params = {}){
    params.search="search";
    this.getSearchList(params);
  }

  getSearchList(params = {}) {
    if (this.tabkey) params.tabkey = this.tabkey;
    if(this.tabkey=='1'){
      API.getRewardsRecord1Tables(params).then((data)=>{
        this.tableinfo = data.tables;
        this.isshowrecord = data.isShowRecord
      })
    }
    API.getSearchList(params).then((data) => {
        this.table.getDatas(data.sessionkey);
    });
  }

  changeTab(key) {
    this.tabkey = key;
    this.form = new WeaForm();
    this.getData();
  }

  getFormParams() {
    return this.form.getFormParams();
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/stores/rewardsrecord.js